import { Layout } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { FormikErrors } from "formik";
import { FormEvent, PropsWithChildren } from "react";

import { TemplateNavigation } from "./TemplateNavigation";
import { Schemas } from "../../../types";

interface Props extends PropsWithChildren {
  templateType: Schemas["TemplateTypeEnum"];
  isValid: boolean;
  handleSubmit?: (e?: FormEvent<HTMLFormElement> | undefined) => void;
  validateForm?: (
    values?: any
  ) => Promise<FormikErrors<any> | FormikErrors<any> | undefined>;
}

export function TemplateLayout(props: Props) {
  const { children, ...params } = props;

  return (
    <Layout layout="narrow" header={<TemplateNavigation {...params} />}>
      <div className={styles.stepContainer}>{children}</div>
    </Layout>
  );
}

const styles = {
  stepContainer: css({
    paddingTop: "var(--space-6)",
  }),
};
